import {
	FORM_CONTROL_ID_PREFIX,
	FORM_FIELDSET_ID_PREFIX
} from './../constants';

/**
 *
 * @param value nome del campo
 * @returns id per il controllo form con lo stesso prefisso previsto in InputLabelComponent
 */
export function prefixInput(value: string = ''): string {
	return sanitizeFormControlName(`${FORM_CONTROL_ID_PREFIX}${value}`);
}

/**
 *
 * @param value nome del campo
 * @returns id per il fieldset del form per contestualizzare
 *  quei campi input che hanno nome identico in fieldset diversi
 */
export function prefixFieldset(value: string = ''): string {
	return sanitizeFormControlName(`${FORM_FIELDSET_ID_PREFIX}${value}`);
}

/**
 *
 * @param fcName nome del controllo form
 * @returns nome sanificato da spazi e caratteri speciali per
 *  id del controllo form ()
 */
export function sanitizeFormControlName(fcName: string): string {
	return fcName.replace(/[^a-zA-Z0-9-]/g, '');
}
